import type { FC } from 'react'
import { useRoutes } from 'react-router-dom'
import { ThemeProvider } from '@material-ui/core'
import LogRocket from 'logrocket'
import './i18n'
import GlobalStyles from './components/GlobalStyles'
import RTL from './components/RTL'
import SettingsDrawer from './components/SettingsDrawer'
import SplashScreen from './components/SplashScreen'
import useAuth from './hooks/useAuth'
import useScrollReset from './hooks/useScrollReset'
import useSettings from './hooks/useSettings'
import routes from './routes'
import { createTheme } from './theme'

if (process.env.NODE_ENV !== 'development') {
  LogRocket.init('bise28/australis', {
    network: {
      requestSanitizer: (request) => {
        // if the url contains 'ignore'
        if (request.url.toLowerCase().indexOf('messaging') !== -1) {
          // ignore the request response pair
          return null
        }

        // otherwise log the request normally
        return request
      }
    }
  })
}

const App: FC = () => {
  const content = useRoutes(routes)
  const { settings } = useSettings()
  const auth = useAuth()
  useScrollReset()

  const theme = createTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: settings.theme
  })

  return (
    <ThemeProvider theme={theme}>
      <RTL direction={settings.direction}>
        <GlobalStyles />
        <SettingsDrawer />
        {auth.isInitialized ? content : <SplashScreen />}
      </RTL>
    </ThemeProvider>
  )
}

export default App
